<template>
  <f-form
    store="@freebe/documents"
    :id="id"
  >
    <template #default="{ item }">
      <h4>{{ docType }}</h4>
      
      <div class="is-grid">
        <f-field 
          class="is-col-3"
          label="Type"
        >
          <f-input 
            v-model="item.type"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Date"
        >
          <f-input 
            v-model="item.date"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Numerotation"
        >
          <f-input 
            v-model="item.numerotation"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Numerotation Freebe"
        >
          <f-input 
            v-model="item.numerotation_freebe"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="État"
        >
          <f-input 
            v-model="item.state"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Status"
        >
          <f-input 
            v-model="item.status"
            readonly
          ></f-input>
        </f-field>

                <f-field 
          class="is-col-3"
          label="Prix HT"
        >
          <f-input 
            v-model="item.total.ht"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Prix TTC"
        >
          <f-input 
            v-model="item.total.ttc"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Prix net"
        >
          <f-input 
            v-model="item.total.net"
            readonly
          ></f-input>
        </f-field>
      </div>

      <h4>Client</h4>

      <div class="is-grid">
        <f-field 
          class="is-col-3"
          label="Nom"
        >
          <f-input 
            v-model="item.client.name"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Email"
        >
          <f-input 
            v-model="item.client.email"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Téléphone"
        >
          <f-input 
            v-model="item.client.phone"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Adresse de facturation"
        >
          <f-input 
            v-model="item.client.address_billing"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Type de prestation"
        >
          <f-input 
            v-model="item.client.prestation_type"
            readonly
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="TVA"
        >
          <f-input 
            v-model="item.client.tva"
            readonly
          ></f-input>
        </f-field>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  
  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
    },

    setup (props) {
      const { get } = useStore('@freebe/documents')
      
      const document = computed(() =>
        get(props.id)
      )
      
      const mapTypes = {
        'invoices': 'Facture',
        'quotations': 'Devis',
        'credits': 'Avoir',
      }

      const docType = computed(() => {
        return mapTypes[document.value.type] || 'Document'
      })

      return {
        docType,
      }
    }
  }
</script>